import React, { useState } from "react";
import BankProgressBar from "../progress_bar/ProgressBar";
import DepositHistory from "../deposit_history/depositHistory";

import deposit from "../../images/Deposit.png";
import reset from "../../images/Reset.png";

// ALERTS \\
import Alert from "react-bootstrap/Alert";
import "./WordSubmit.css";
// boottrap css below
import "bootstrap/dist/css/bootstrap.min.css";

const usedWords = [];
let usedLetter = {};

function WordSubmitForm({
  words,
  addTodo,
  data,
  letterList,
  listLength,
  mustUse,
}) {
  // state for the word being submitted
  const [value, setValue] = useState("");
  // state to track the current score
  const [score, setScore] = useState(0);
  // State to update the progress of the status bar
  const [progressStatusNow, setProgressStatusNow] = useState(0);
  // state that handle alerts
  const [missingMustUseLetter, setMissingMustUseLetter] = useState(false);
  // state to track if a word has been used yet or not
  const [notAWordInWordList, setnotAWordInWordList] = useState(false);
  // state to track if the user asks for the must use letter if the styling of the letter is not clear enough
  const [mustUseLetter, setMustUseLetter] = useState(false);
  // state checking if a word has been submitted
  const [submitted, setSubmitted] = useState(false);

  const [show, setShow] = useState(true);


  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    resetWord(e);
    if (!value) return;

    // ***CORE GAME FUNCTIONALITY*** \\
    // check if our used list contains the word submitted
    if (usedWords.includes(value) === false) {
      // does the word not in the used list contain the muse use letter as well?
      if (value.includes(mustUse) === false) {
        // console.log(`Must use letter ${mustUse}`);
        // missingMustUseLetter is being used for the alert system "missing msut use letter"
        setMissingMustUseLetter(true);
      }
      // notAWordInWordList is being used for the alert system "not a valid word"
      else if (data.data.word_list.includes(value) === false) {
        // console.log(`${value} is not a valid word`);
        setnotAWordInWordList(true);
      }
      // - GAME MECHANIC - \\
      // IF the word passes both tests for the mustUse letter and being a valid word THEN we want to add that letter to the usedWords array so we can not re-use that letter
      // ADD THE WORD TO THE WORD BANK
      // INCREASE OUR SCORE FOR A VALID WORD
      // MOVE OUR PROGRESS BAR USING THE UPDATE PB FUNCTION
      // RESET DISPLAY OF CHOSEN WORD SO THE USER CAN EASILY BEGIN ANOTHER WORD
      else {
        usedWords.push(value);
        addTodo(value);
        setScore(score + 1);
        updateProgressBar(e);
        setValue("");
      }
    }
    // ANY EDGE CASE IN THE SUBMIT SHOULD SIMPLY RESET OUR WORD ON DISPLAY
    else {
      setValue("");
    }
  };

  // - GAME MECHANIC - \\
  // SELECT A LETTER FN
  const submitLetter = (e) => {
    e.preventDefault();
    // console.log("clicked submitLetter", e.target.value);

    // if the selected letter is not in our dict of usedLetters:
    if (!(e.target.value in usedLetter)) {
      usedLetter[e.target.value] = e.target.value;
      let x = [...value, e.target.value];
      let splitJoin = x.join("");
      // console.log("clicked before update", value);

      setValue(splitJoin);
      // console.log("clicked after udpate", value);
    } else {
      return "Submit Letters is not working properly.";
    }
  };

  // RESET STATE
  const resetWord = (e) => {
    e.preventDefault();
    setMissingMustUseLetter(false);
    setnotAWordInWordList(false);
    setMustUseLetter(false);
    setValue("");
    usedLetter = [];
  };

  // ## PROGRESS BAR STUFF ## \\
  const updateProgressBar = (e) => {
    e.preventDefault();
    let x = ((score + 1) / listLength) * 100;
    setProgressStatusNow(Math.floor(x));
    // console.log("SCORE", score);
    // console.log("progressStatusNow", progressStatusNow);
  };

  const handleClose = (e) => {
    e.preventDefault();
    setMissingMustUseLetter(false);
    setnotAWordInWordList(false);
  };

  return (
    <>
      {missingMustUseLetter === true ? (
        <div className="alert-and-progress-wrapper">
          <Alert onClose={show}>
            <h3 className="missing-must-use">
              You are missing the must use letter.
            </h3>
            <p className="please-use">
              Please use: <span className="must-use-alert">{mustUse}</span>{" "}
            </p>
            <button className="clear-alert-btn" onClick={handleClose}>
              CLEAR
            </button>
          </Alert>
        </div>
      ) : (
        ""
      )}
      {notAWordInWordList === true ? (
        <div className="alert-and-progress-wrapper">
          <Alert onClose={show}>
            <h3>That is not a valid word.</h3>
            <button onClick={handleClose}>CLEAR</button>
          </Alert>
        </div>
      ) : (
        ""
      )}

      <form>
        <div className="wordbank">
          <BankProgressBar
            score={score}
            progressStatusNow={progressStatusNow}
          />

          <div className="todo-wrapper">
            <div className="todo-inner-wrapper">
              {words.map((todo, index) => (
                <DepositHistory key={index} index={index} todo={todo}/>
              ))}
            </div>
          </div>
          </div>
 
        <div className="word-submit">
          <div className="select-letters">
            {letterList.map((e) =>
              e === mustUse ? (
                <a href="/"
                  className="must-use"
                  value={e}
                  key={e}
                  onClick={submitLetter}
                >
                  <button value={e}
                  key={e}
                  onClick={submitLetter} id="letter-">{e}</button>
                </a>
              ) : (
                <a href="/"
                  className="reg-letter"
                  value={e}
                  key={e}
                  onClick={submitLetter}
                >
              <button value={e}
                  key={e}
                  onClick={submitLetter} id="letter-">{e}</button>
                </a>
              )
            )}
          </div>
          <div className="piggy-bank-wrapper">
            <div className="chosen-word"> Chosen Word: {value}</div>

          <div className="choose-a-word-btns">

            <a href="#" className="deposit-btn" onClick={handleSubmit}>
              <img src={deposit} alt="deposit here" width="100" height="100" />
            </a>


            <a href="#" onClick={resetWord} className="reset-btn">
              <img src={reset} alt="deposit here" width="100" height="100" />
            </a>

            
          </div>
        </div>
        </div>
      </form>
    </>
  );
}

export default WordSubmitForm;
